<template>
  <div>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-card>
            <v-card-title>
              <span class="text-h5">Prompts (par Process)</span>
              <v-spacer></v-spacer>
              <v-col cols="3">
                <v-autocomplete
                  v-model="selectedSiteId"
                  :items="siteList"
                  item-text="name"
                  item-value="id"
                  label="Filtrer par site"
                  dense
                  outlined
                  clearable
                  hide-details
                ></v-autocomplete>
              </v-col>
            </v-card-title>

            <!-- Main Tabs -->
            <v-tabs v-model="mainActiveTab" class="px-4">
              <v-tab>Process via Angles</v-tab>
              <v-tab>Process via Mots-clés</v-tab>
              <v-tab>Process via Lot de Sources</v-tab>
              <v-tab>Redac Process</v-tab>
              <v-tab>News Radar (Full AI)</v-tab>
              <v-tab>Auto Keyword</v-tab>
              <v-tab>Internal Linking</v-tab>
              <v-tab>Scraping</v-tab>
              <v-tab>Image</v-tab>
            </v-tabs>

            <v-tabs-items v-model="mainActiveTab">
              <!-- Process via Angles Tab — LLPR direct -->
              <v-tab-item>
                <prompt-manager
                  title="Process via Angles (LLPR)"
                  :prefixes="['AIF_SOURCES_SEARCH_ANGLES']"
                  :allowed-providers="['perplexity']"
                  default-new-template-prefix="AIF Sources Search Angles "
                />
              </v-tab-item>

              <!-- Process via Mots-clés Tab — LLPR direct -->
              <v-tab-item>
                <prompt-manager
                  title="Process via Mots-clés (LLPR)"
                  :prefixes="['AIF_SOURCES_SEARCH_KW']"
                  default-new-template-prefix="AIF Sources Search KW "
                />
              </v-tab-item>

              <!-- Process via Lot de Sources Tab — LLPR direct -->
              <v-tab-item>
                <prompt-manager
                  title="Process via Lot de Sources (LLPR)"
                  :prefixes="['AIF_URLBATCH']"
                  default-new-template-prefix="AIF URL Batch "
                />
              </v-tab-item>

              <!-- Redac Process Tab -->
              <v-tab-item>
                <redac-process-tab :siteId="selectedSiteId" />
              </v-tab-item>

              <!-- News Radar (Full AI) Tab — LLPR direct -->
              <v-tab-item>
                <prompt-manager
                  title="News Radar — Full AI (LLPR)"
                  :prefixes="['AIF_NEWS_RADAR']"
                  default-new-template-prefix="AIF News Radar "
                />
              </v-tab-item>

              <!-- Auto Keyword Tab — LLPR direct -->
              <v-tab-item>
                <prompt-manager
                  title="Auto Keyword (LLPR)"
                  :prefixes="['AIF_KWAUTO']"
                  default-new-template-prefix="AIF KWAuto "
                />
              </v-tab-item>

              <!-- Internal Linking Tab — LLPR direct -->
              <v-tab-item>
                <prompt-manager
                  title="Internal Linking (LLPR)"
                  :prefixes="['AIF_INTERNAL_LINKING']"
                  default-new-template-prefix="AIF Internal Linking "
                />
              </v-tab-item>

              <!-- Scraping Tab — LLPR direct -->
              <v-tab-item>
                <prompt-manager
                  title="Scraping — Nettoyage HTML / PDF (LLPR)"
                  :prefixes="['SCRAPING']"
                  default-new-template-prefix="SCRAPING "
                />
              </v-tab-item>

              <!-- Image Tab — LLPR direct -->
              <v-tab-item>
                <prompt-manager
                  title="Génération d'image (LLPR)"
                  :prefixes="['AIF_IMAGE']"
                  default-new-template-prefix="AIF Image "
                />
              </v-tab-item>
            </v-tabs-items>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import axios from "@axios";
import RedacProcessTab from "@/components/admin/ai-factory/prompts-config/RedacProcessTab.vue";
import ScoreVeilleTab from "@/components/admin/ai-factory/prompts-config/NewsRadarScoring.vue";
import PromptManager from "@/components/llpr/PromptManager.vue";

export default {
  name: "PromptConfig",

  components: {
    RedacProcessTab,
    ScoreVeilleTab,
    PromptManager,
  },

  data() {
    const routeSiteId = Number(this.$route.query.site_id || 0);
    return {
      mainActiveTab: 3,
      selectedSiteId: routeSiteId > 0 ? routeSiteId : null,
      siteList: [],
    };
  },

  computed: {},

  methods: {},

  beforeDestroy() {
    this.$store.commit("appConfig/UPDATE_APP_CONTENT_WIDTH", "boxed");
  },

  async mounted() {
    this.$store.commit("appConfig/UPDATE_APP_CONTENT_WIDTH", "fullWidth");
    try {
      const response = await axios.get("/sites/", {
        params: { sort_by: "name" },
      });
      this.siteList = response.data?.items || [];
      // User restreint par site : le back clampe de toute facon, mais on
      // pre-selectionne son site pour ne jamais partir en mode "tous les sites".
      if (this.$store.getters["common/getIsSiteRestricted"]) {
        const accessible = this.$store.getters["common/getAccessibleSiteIds"];
        this.siteList = this.siteList.filter((s) => accessible.includes(s.id));
        if (!this.selectedSiteId && this.siteList.length) {
          this.selectedSiteId = this.siteList[0].id;
        }
      }
    } catch (error) {
      console.error("Error loading site list:", error);
    }
  },
};
</script>
